export default "__VITE_ASSET__Cs1OYMeM__"